var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{'is-active': _vm.tabTitle === _vm.removeDash},on:{"click":function($event){return _vm.switchActiveTab()}}},[_c('a',[_vm._v("\n    "+_vm._s(_vm.toUpperCase)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }